import * as React from 'react';
import './practicalSectionResultNotificationPane.module.scss';
import { PracticalSectionResultNotification } from '../../../../types/notifications';
import { TwitterShareButton } from '../../../atoms/buttons/TwitterShareButton';
import { FacebookShareButton } from '../../../atoms/buttons/FacebookShareButton';

type Props = {
  notification: PracticalSectionResultNotification;
};

class GradeA extends React.Component<Props> {
  render() {
    const { notification } = this.props;
    const prefillText = `${notification.course_title}の実技試験をクリアしました！`;
    const ogpUrl = `https://shelikes.jp/v3/exam_practical_submissions/${notification.submission_code}`;
    return (
      <div styleName="pane">
        <div styleName="thumbnail grade-a">
          <div styleName="score-wrapper">
            <div styleName="score">
              <span styleName="score-text">{notification.score}</span>
              <span styleName="suffix-text">点</span>
            </div>
          </div>
          <div styleName="titles">
            <div styleName="course-title">{notification.course_title}</div>
            <div styleName="section-title">{notification.section_title}</div>
          </div>
        </div>
        <div styleName="main">
          <div styleName="text">試験に合格しました！</div>
          <div styleName="text">おめでとうございます！</div>
        </div>
        <div styleName="sub">
          <div styleName="text">
            {notification.course_title}
            {notification.section_title}を合格しました！
          </div>
          <div styleName="text">この調子で学習をつづけましょう。</div>
        </div>
        <div styleName="button-toolbar">
          <TwitterShareButton dataText={prefillText} dataUrl={ogpUrl}>
            Twitterでシェア
          </TwitterShareButton>
          <FacebookShareButton dataUrl={ogpUrl}>Facebookでシェア</FacebookShareButton>
        </div>
      </div>
    );
  }
}

class GradeB extends React.Component<Props> {
  render() {
    const { notification } = this.props;
    const prefillText = `${notification.course_title}の実技試験にチャレンジしました`;
    const ogpUrl = `https://shelikes.jp/v3/exam_practical_submissions/${notification.submission_code}`;
    return (
      <div styleName="pane">
        <div styleName="thumbnail grade-b">
          <div styleName="score-wrapper">
            <div styleName="score">
              <span styleName="score-text">{notification.score}</span>
              <span styleName="suffix-text">点</span>
            </div>
          </div>
          <div styleName="titles">
            <div styleName="course-title">{notification.course_title}</div>
            <div styleName="section-title">{notification.section_title}</div>
          </div>
        </div>
        <div styleName="main">
          <div styleName="text">試験の結果が届きました。</div>
          <div styleName="text">おしい！合格までもう少しです</div>
        </div>
        <div styleName="sub">
          <div styleName="text">合格の80点まで、あともう少しです。</div>
          <div styleName="text">合格めざして頑張りましょう！</div>
        </div>
        <div styleName="button-toolbar">
          <TwitterShareButton dataText={prefillText} dataUrl={ogpUrl}>
            Twitterでシェア
          </TwitterShareButton>
          <FacebookShareButton dataUrl={ogpUrl}>Facebookでシェア</FacebookShareButton>
        </div>
      </div>
    );
  }
}

class GradeC extends React.Component<Props> {
  render() {
    const { notification } = this.props;
    const prefillText = `${notification.course_title}の実技試験にチャレンジしました`;
    const ogpUrl = `https://shelikes.jp/v3/exam_practical_submissions/${notification.submission_code}`;
    return (
      <div styleName="pane">
        <div styleName="thumbnail grade-c">
          <div styleName="score-wrapper">
            <div styleName="score">
              <span styleName="score-text">{notification.score}</span>
              <span styleName="suffix-text">点</span>
            </div>
          </div>
          <div styleName="titles">
            <div styleName="course-title">{notification.course_title}</div>
            <div styleName="section-title">{notification.section_title}</div>
          </div>
        </div>
        <div styleName="main">
          <div styleName="text">試験の結果が届きました。</div>
          <div styleName="text">ひきつづき頑張りましょう！</div>
        </div>
        <div styleName="sub">
          <div styleName="text">合格の80点には届きませんでした。</div>
          <div styleName="text">分からない部分はコースを見返して合格を目指しましょう。</div>
        </div>
        <div styleName="button-toolbar">
          <TwitterShareButton dataText={prefillText} dataUrl={ogpUrl}>
            Twitterでシェア
          </TwitterShareButton>
          <FacebookShareButton dataUrl={ogpUrl}>Facebookでシェア</FacebookShareButton>
        </div>
      </div>
    );
  }
}

export class PracticalSectionResultNotificationPane extends React.Component<Props> {
  render() {
    const { notification } = this.props;
    if (!notification) {
      return null;
    }
    if (notification.score >= 80) {
      return <GradeA notification={notification} />;
    } else if (notification.score >= 60) {
      return <GradeB notification={notification} />;
    } else {
      return <GradeC notification={notification} />;
    }
  }
}
